import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "checkboxShow", "addTransferBtn", "clearListBtn", "optionBtn"]

  connect() {
    this.controllerName = `operations--products--clinics--financials--transfers--index`
    this.tableCols = 6
    this.itemsOnPage = 100
    this.pageNumber = 0
    this.numberPages = []
    this.sort = { mode: `asc`, field: `status_pretty` }
    this.hasShow = false

    if (this.getControllerByIdentifier("operations--products--clinics--financials--transfers--dashboard")) {
      this.dashboardController = this.getControllerByIdentifier(`operations--products--clinics--financials--transfers--dashboard`)
    } else if (this.getControllerByIdentifier("operations--products--clinics--clients--transfers--dashboard")) {
      this.dashboardController = this.getControllerByIdentifier(`operations--products--clinics--clients--transfers--dashboard`)
    }
  }

  showTransfer(ev) {
    var controllerShow = this.getControllerByIdentifier("operations--products--clinics--financials--transfers--show")
    var transferId = ev.target.closest(".itemRow").dataset.id

    this.application.transfers.forEach(element => {
      if (element.id == transferId) {
        controllerShow.current_transfer = element
      }
    })

    controllerShow.doTransferHtml()
  }

  addTransfer() {
    var date = new Date()

    if (this.application.current_date.open) {
      if (this.application.current_date.year == date.getFullYear() && this.application.current_date.month == date.getMonth() + 1) {
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(`danger`, `A Competência não foi Encerrada!`, 2000)
      } else {
        this.getControllerByIdentifier("operations--products--clinics--financials--transfers--save").actionMode = "new"
        this.getControllerByIdentifier("operations--products--clinics--financials--transfers--save").current_transfer = {}
        this.getControllerByIdentifier("operations--products--clinics--financials--transfers--save").doFormHtml()
      }
    } else {
      this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(`danger`, `A Competência já foi Fechada!`, 4000)
    }

  }

  editTransfer(ev) {
    var id = ev.currentTarget.closest(".itemRow").dataset.id
    this.application.transfers.forEach(element => {
      if (element.id == id) {
        this.getControllerByIdentifier("operations--products--clinics--financials--transfers--save").current_transfer = element
      }
    })
    this.getControllerByIdentifier("operations--products--clinics--financials--transfers--save").actionMode = "edit"
    this.getControllerByIdentifier("operations--products--clinics--financials--transfers--save").doFormHtml()
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doIndexListHtml() {

    if (this.application.permissions[this.permission].can_create) {
      var addLine = `<span data-action="click->${this.controllerName}#addTransfer" class="dropdown-item py-1 pointer dropdown-submenu-item">Adicionar Repasse</span>`
    } else {
      var addLine = ``
    }

    var refreshLine = `<span data-action="click->${this.controllerName}#refreshTransfer" class="dropdown-item py-1 pointer dropdown-submenu-item">Atualizar Repasses ${this.application.current_date.name}</span>`

    var clearBtnHtml = `<span class="mc-tooltip">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0 d-none" data-${this.controllerName}-target="clearListBtn" data-action="click->${this.controllerName}#clearList" type="button">
                            <span class="material-icons md-dark">clear</span>
                          </button>
                          <span class="mc-tooltiptext">Limpar</span>
                        </span>`

    var submenuHtml = `<div class="dropdown mc-tooltip" data-${this.controllerName}-target="optionBtn">
                        <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-toggle="dropdown" id="submenuMenuDrop" type="button"><span class="material-icons md-dark">more_vert</span></button>
                        <div aria-labelledby="submenuMenuDrop" class="dropdown-menu dropdown-menu-right menu" style="font-size:80%">
                          ${addLine}
                          ${refreshLine}
                        </div>
                        <span class="mc-tooltiptext">Opções</span>
                      </div>`


    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-header-font">Repasses | ${this.application.current_date.name}</h6>
                    <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                    <div class="card-actions ml-auto py-0">
                      ${clearBtnHtml}
                      ${submenuHtml}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" style="font-size:80%;">
                          <thead>
                            <tr>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-25 align-middle">Sócio</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">Tipo</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">Valor Bruto</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">IRRF</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">INSS</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">Valor Líquido</th>
                            </tr>
                          </thead>
                          <tbody data-${this.controllerName}-target="bodyTable">
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.dashboardController.listTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.6) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 10))
      controller.doDataTable()
    })
  }

  doDataTable() {
    var current_transfers = []

    if (this.application.current_user.account_kind == `admin` || this.application.current_user.account_kind == `team`) {
      this.application.transfers.forEach(element => {
        if (element.date_id == this.application.current_date.id) {
          current_transfers[current_transfers.length] = element
        }
      })
    } else if (this.application.current_user.account_kind == `doctor`) {
      this.application.transfers.forEach(element => {
        if (element.date_id == this.application.current_date.id && element.partner_id == this.application.current_partner.id) {
          current_transfers[current_transfers.length] = element
        }
      })
    } else if (this.application.current_user.account_kind == `helper`) {

    }

    if (this.sort.mode == `asc`) {
      var transfers = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(current_transfers, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var transfers = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(current_transfers, this.sort.field)
    }

    if (transfers.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(transfers.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (transfers[x] !== undefined) {
            internPage[internPage.length] = transfers[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: transfers.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="${this.tableCols}" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Repasses na ${this.application.current_date.name}</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.transferTablePartial(element, data.length))
      });
    }

  }

  transferTablePartial(element, length) {

    if (element.status == `active`) {
      var status = `<span class="mc-tooltip badge badge-success"><span class="material-icons md-sm md-white default">done</span><span class="mc-tooltiptext">${element.status_pretty}</span></span>`
    } else if (element.status == `inactive`) {
      var status = `<span class="mc-tooltip badge badge-danger"><span class="material-icons md-sm md-white default">clear</span><span class="mc-tooltiptext">${element.status_pretty}</span></span>`
    }

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}">`
    }

    var rowHtml = `${tableRow}
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#showTransfer">${element.partner_name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#showTransfer">${element.kind_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.getControllerByIdentifier("app--helpers--numbers").currencyMask(Math.round(element.amount * 100))}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.getControllerByIdentifier("app--helpers--numbers").currencyMask(Math.round(element.withheld * 100))}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.getControllerByIdentifier("app--helpers--numbers").currencyMask(Math.round(element.social * 100))}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.getControllerByIdentifier("app--helpers--numbers").currencyMask(Math.round(element.net_amount * 100))}</td>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="card-actions align-items-center justify-content-end py-0 f-065">
                        <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                        <div class="dropdown">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${pagination.itemsOnPage}</button>
                          <div class="dropdown-menu dropdown-menu-right menu">
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="100">100</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="250">250</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="500">500</span>
                          </div>
                        </div>
                        <span class="align-self-center mb-1 mr-2 text-muted">${pagination.fromItem}-${pagination.toItem} de ${pagination.totalItems}</span>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  clearList() {
    this.clearListBtnTarget.classList.add(`d-none`)
    this.optionBtnTarget.classList.remove(`d-none`)

    this.getControllerByIdentifier("operations--products--clinics--financials--transfers--show").doViewHtml()
    this.getControllerByIdentifier("operations--products--clinics--financials--transfers--save").stopRefreshing()
    this.doDataTable()
  }

  refreshTransfer() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()
    this.send_data = { current_user: {}, transfer: {} }

    this.send_data.transfer.clinic_id = this.application.clinic.id
    this.send_data.transfer.date_id = this.application.current_date.id

    this.send_data.current_user.current_user_id = this.application.current_user.id
    this.send_data.current_user.feature = this.permission

    var url = "/operations/products/clinics/financials/transfers/list_by_date"
    var method = "POST"
    var controller = this
    var init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }

    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          var currentIds = controller.mapElements(controller.application.transfers, `id`)
          var responseIds = controller.mapElements(response.data.cln, `id`)


          response.data.cln.forEach(new_transfer => {
            if (currentIds.includes(new_transfer.id) && responseIds.includes(new_transfer.id)) {
              controller.application.transfers.forEach((element, i) => {
                if (element.id == new_transfer.id) {
                  controller.application.transfers.splice(controller.application.transfers.indexOf(element), 1, new_transfer)
                }
              })
            } else if (currentIds.includes(new_transfer.id)) {
              controller.application.transfers.forEach((element, i) => {
                if (element.id == new_transfer.id) {
                  controller.application.transfers.splice(controller.application.transfers.indexOf(element), 1)
                }
              })
            } else if (responseIds.includes(new_transfer.id)) {
              controller.application.transfers[controller.application.transfers.length] = new_transfer
            }
          })

          controller.doDataTable()
        }
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error, `Tivemos problemas para atualizar os Impostos`)
      })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    this.getControllerByIdentifier("app--helpers--console").console(results)
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
